<template lang="pug">
v-container.receipt-list-info
  template(v-for="receipt in receipts")
    base-text-divider {{ receipt.serialNumber }}
    v-layout(
      wrap
      justify-start)
      v-flex.text-xs-left
        .body-2 繳款會員： {{ receipt.payer.displayName }}
      v-flex.text-xs-left
        .body-2 總額： {{ receipt.total }}
      v-flex.text-xs-left
        .body-2 經手人： {{ receipt.payee.displayName }}
    v-layout(
      wrap
      justify-start)
      v-flex.text-xs-left
        .body-2 核對狀態： {{ receipt.settled | boolean }}
      v-flex.text-xs-left
        .body-2 作廢狀態： {{ receipt.disabled | boolean }}
    v-layout(wrap).mb-3
      receipt-item-chip(
        v-for="item in receipt.items"
        :year="item.year"
        :text="item | receiptItemFilter")
  base-text-divider 合計
  .text-xs-center.red--text.title {{ total }}
</template>
<script>
import BaseTextDivider from "@/components/core/BaseTextDivider.vue";
import ReceiptItemChip from "@/components/core/ReceiptItemChip.vue";

export default {
  name: "ReceiptListInfo",
  props: {
    receipts: {
      type: Array,
      require: true
    }
  },
  components: {
    BaseTextDivider,
    ReceiptItemChip
  },
  computed: {
    total() {
      return this.receipts.reduce((acc, r) => {
        acc += r.total;
        return acc;
      }, 0);
    }
  }
};
</script>
